package fr.frux.feature.map

import fr.frux.core.ads.AdsController
import fr.frux.core.ads.RewardedResult
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

/**
 * Lance la vidéo récompensée du lien « Regarder une vidéo pour 24 h sans pub » (#531) dans le scope du ViewModel
 * permanent de la carte (ADR 0009). Un second appui pendant la vidéo est ignoré, une vidéo fermée
 * avant la fin ne remonte rien. [MapState.rewardedLoading] suit toute la durée du geste (chargement compris) pour que
 * le lien reste affiché, désactivé.
 */
internal class RewardedAdLauncher(
    private val scope: CoroutineScope,
    private val ads: AdsController?,
    private val state: MutableStateFlow<MapState>,
) {
    private var job: Job? = null

    fun launch() {
        val controller = ads ?: return
        if (job?.isActive == true) return
        job =
            scope.launch {
                state.update { it.copy(rewardedLoading = true) }
                try {
                    val result = controller.watchRewardedForAdFree()
                    if (result != RewardedResult.DISMISSED) state.update { it.copy(rewardedResult = result) }
                } finally {
                    state.update { it.copy(rewardedLoading = false) }
                }
            }
    }
}
